import { render, staticRenderFns } from "./RevisionsPanel.vue?vue&type=template&id=634b45e4&"
import script from "./RevisionsPanel.vue?vue&type=script&lang=ts&"
export * from "./RevisionsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports